import * as React from 'react'
import { SVGProps } from 'react'
const MainLogoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={19}
    fill="none"
    {...props}
  >
    <path
      stroke={props.color || '#CF3D42'}
      strokeWidth={2.08}
      d="M1.2 5.4v3.289a4 4 0 0 0 1.3 2.952L8 16.669m0 0v2.33m0-2.33 5.498-5.028A4 4 0 0 0 14.8 8.689v-3.29"
    />
    <path
      stroke={props.color || '#CF3D42'}
      strokeWidth={2.4}
      d="M8.001 6.2v6.4M8 1.4l2.424 1.4v2.8L8 7 5.574 5.6V2.8L8 1.4Z"
    />
  </svg>
)
export default MainLogoIcon
